var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.path)?_c('el-link',{style:({ 'max-height': '18px', 'font-size': _vm.fontSize }),attrs:{"type":"primary"},on:{"click":function($event){!_vm.apiName ? _vm.showView() : false}}},[_vm._v(" "+_vm._s(_vm.name || "查看文件")+" "),(_vm.isIcon)?_c('i',{staticClass:"el-icon-view el-icon--right"}):_vm._e(),(_vm.showViewer)?_c('el-image-viewer',{attrs:{"zIndex":9999,"url-list":_vm.viewerlList,"on-close":() => {
        _vm.showViewer = false;
        _vm.clear();
      }}}):_vm._e()],1):_c('el-link',{style:({ 'font-size': _vm.fontSize })},[_vm._v("无")])
}
var staticRenderFns = []

export { render, staticRenderFns }